import React from 'react'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { defineMessages } from 'react-intl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import {
  getIdReduxUtil,
  getValueReduxUtil
} from '@gymaholic/packages'
import PlanCircle from 'pages/Creator/Plans/PlanCircle/index.js'
import Flex from 'components/Flex/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'
import { getStartedPlansSelector } from 'modules/plan/redux/selectors/index.js'
import { loadStartedPlansAction } from 'modules/plan/redux/actions/index.js'

const messages = defineMessages({
  startedPlan: {
    id: 'StartedPlan.startedPlan',
    defaultMessage: 'Started plan'
  }
})

const ANALYTIC_EVENT = {
  VIEW_SUGGESTED_PLAN: 'VIEW_SUGGESTED_PLAN',
  SHOW_SUGGESTED_PLAN: 'SHOW_SUGGESTED_PLAN'
}

export function StartedPlan () {
  const intl = useIntl()
  const dispatch = useDispatch()
  const startedPlans = useSelector(getStartedPlansSelector())
  const startedPlan = (startedPlans || []).find(plan => {
    const wasLogged = getValueReduxUtil(plan, 'loggedAt')
    const wasStarted = getValueReduxUtil(plan, 'startedAt')
    return wasStarted && !wasLogged
  })
  const id = getIdReduxUtil(startedPlan)
  const hasStartedPlan = (
    !!startedPlan
  )
  React.useEffect(() => {
    dispatch(loadStartedPlansAction())
  }, [])

  React.useEffect(() => {
    if (hasStartedPlan) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_SUGGESTED_PLAN)
    }
  }, [hasStartedPlan])

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_SUGGESTED_PLAN)
  }

  if (!id) {
    return
  }

  if (!hasStartedPlan) {
    return <></>
  }

  return (
    <Flex
      mt='16px'
      mx='32px'
      py='11px'
      ac
      jc
      bdr
      bd
    >
      <TextTitleCondensed>
        {formatMessageIntlUtil(intl, messages.startedPlan)}
      </TextTitleCondensed>

      <PlanCircle
        planId={id}
        onClick={handleClick}
        isSelected
        showOpenButton
      />
    </Flex>
  )
}
